export const subscribeTypes = [
  {
    text: 'Consignment Status Updated',
    value: 'consignment.status.updated'
  },
  {
    text: 'Consignment Size Updated',
    value: 'consignment.size.updated'
  },
  {
    text: 'Consignment Price Updated',
    value: 'consignment.price.updated'
  },
  {
    text: 'Consignment Delivered',
    value: 'consignment.delivered'
  }
];

export const serviceTypes = [
  {
    text: 'JSON',
    value: 'JSON'
  },
  {
    text: 'SOAP',
    value: 'SOAP'
  }
];

export const securityTypes = [
  {
    text: 'None',
    value: 'none'
  },
  {
    text: 'Basic',
    value: 'basic'
  },
  {
    text: 'Header',
    value: 'header'
  },
  {
    text: 'Bearer',
    value: 'bearer'
  }
];

function generateRandomData(maxWeight = 70, step = 0.5) {
  const data = {
    status: true,
    message: '',
    data: {
      columns: Array.from({ length: 8 }, (_, i) => ({
        id: i + 1,
        provider_id: 1,
        name: `Bölge ${i + 1} Adı`,
        created_at: '2024-05-17 12:32:47',
        updated_at: '2024-05-17 12:32:47'
      })),
      rows: []
    }
  };

  let currentMin = 0.001;
  let currentMax = step;

  while (currentMax <= maxWeight) {
    const row = {
      min_val: parseFloat(currentMin.toFixed(3)),
      max_val: parseFloat(currentMax.toFixed(3)),
      region_prices: Array.from({ length: 8 }, () =>
        parseFloat((Math.random() * (20 - 4) + 4).toFixed(2))
      )
    };

    data.data.rows.push(row);
    currentMin = currentMax;
    currentMax += step;
  }

  return data;
}

export const dummyDataRegionPrice = generateRandomData();
